import { endOfDay, startOfDay } from "date-fns";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { DatePicker, Dropdown } from "components";
import "modules/ThreeDepartmentDashboard/components/ThreeDepartmentDashboardFilters/ThreeDepartmentDashboardFilters.scss";
import { setThreeDepartmentFilters, useThreeDepartmentFilters } from "modules/ThreeDepartmentDashboard/hooks";
import { NOT_CHECKED_BY } from "modules/ThreeDepartmentDashboard/queryKeys";

import type { DropdownItemProps } from "components";

export const ThreeDepartmentDashboardFilters = () => {
  const { t } = useTranslation();

  const filters = useThreeDepartmentFilters();

  const [dateFrom, setDateFrom] = useState(filters.date_from);
  const [dateTo, setDateTo] = useState(filters.date_to);

  const handleDateRangeChange = (...[start, end]: (Date | null)[]) => {
    setDateFrom(start);
    setDateTo(end);

    if (start && !end) return;

    setThreeDepartmentFilters({
      ...filters,
      date_from: start ? startOfDay(start) : null,
      date_to: end ? endOfDay(end) : null,
      page: 1
    });
  };

  const handleNotCheckedByChange = (value?: NOT_CHECKED_BY) => {
    setThreeDepartmentFilters({ ...filters, not_checked_by: value ?? null, page: 1 });
  };

  const notCheckedByOptions: DropdownItemProps<NOT_CHECKED_BY>[] = [
    { key: "receptionist", value: NOT_CHECKED_BY.Receptionist, text: t("v8_reception", "Reception"), icon: "user" },
    { key: "parts", value: NOT_CHECKED_BY.Parts, text: t("v8_parts", "Parts"), icon: "gear" },
    { key: "workshop", value: NOT_CHECKED_BY.Workshop, text: t("v8_workshop", "Workshop"), icon: "wrench" }
  ];

  return (
    <div className="ThreeDepartmentDashboardFilters">
      <div className="toolbar-container">
        <Grid className="toolbar-grid">
          <GridColumn width={3} className="no-left-gutter">
            <DatePicker selectsRange showLabel fluid clearable startDate={dateFrom} endDate={dateTo} onDateChange={handleDateRangeChange} />
          </GridColumn>

          <GridColumn width={6} verticalAlign="middle">
            <div className="checked-by">
              <span className="label">{t("v8_not_checked_by", "Not checked by")}</span>
              <Dropdown
                fluid
                selection
                clearable
                selectOnBlur={false}
                placeholder={t("v8_all", "All")}
                value={filters.not_checked_by ?? undefined}
                options={notCheckedByOptions}
                onChange={handleNotCheckedByChange}
              />
            </div>
          </GridColumn>
        </Grid>
      </div>
    </div>
  );
};
